export default __webpack_public_path__ + "static/international-metric-desktop-57ada6afcf245d6a68e133144216aa88.svg";